import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 내 평점 설정
 *
 * Origin: pageNicolasApi.setMyRating
 * API: POST /gateway/api/v5/store/community/set/myrating
 */
export async function postApiStoreCommunitySetMyrating(
  input: {
    series_id: number;
    product_id: number;
    rating: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/store/community/set/myrating',
    {
      method: 'POST',
      data: {
        seriesid: input.series_id,
        singleid: input.product_id,
        rating: input.rating,
      },
    },
    options
  );
  return response.data;
}
